import { Box, Card, CardContent, Grid, Skeleton, Stack } from "@mui/material";

function AddonCardSkeleton() {
  return (
    <Card sx={{ height: "100%", minHeight: 180, borderRadius: 2 }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 1.5 }}>
          <Skeleton variant="rounded" width={40} height={40} />
          <Skeleton variant="rounded" width={72} height={24} />
        </Stack>
        <Skeleton variant="text" width="75%" height={24} />
        <Skeleton variant="text" width="100%" height={16} />
        <Skeleton variant="text" width="90%" height={16} />
        <Skeleton variant="rounded" width="100%" height={36} sx={{ mt: 2 }} />
      </CardContent>
    </Card>
  );
}

export default function AiMarketplaceSkeleton() {
  return (
    <div className="row">
      {Array.from({ length: 6 }).map((_, i) => (
        <div className="col-12 col-md-6 col-xl-4 mb-3" key={i}>
          <AddonCardSkeleton />
        </div>
      ))}
    </div>
  );
}
